/** Conversion, ageing and promo performance, with the AI read on top. */
import StatCards from '../components/StatCards.jsx';
import InsightCards from '../components/InsightCards.jsx';
import BreakdownCard from '../components/BreakdownCard.jsx';
import QueueCard from '../components/QueueCard.jsx';
import { ExplainCard, DigestCard } from '../components/AICards.jsx';

export default function Insights() {
  return (
    <>
      <StatCards view="insights" />
      <ExplainCard />
      {/* The daily digest used to sit on the landing page, which is the
          report now. It belongs beside the other AI reads rather than
          being dropped with the page it happened to live on. */}
      <DigestCard />
      <InsightCards />
      <div className="two">
        <div><BreakdownCard /></div>
        <div><QueueCard limit={10} /></div>
      </div>
    </>
  );
}
